<template>
  <div>
    <v-fab-transition>
      <v-badge
        bordered
        color="white"
        overlap
        :style="STYLE_BTN_COMBINADO"
        v-if="GET_SELECIONADOS_DADOS_TABELA.length > 1"
      >
        <template v-slot:badge>
          <span style="color: #000000">{{ GET_SELECIONADOS_DADOS_TABELA.length }}</span>
        </template>

        <v-btn
          small
          color="warning"
          @click="setDialogCombinar()"
        >
          Combinar <v-icon class="ml-1" small>mdi-vector-combine</v-icon>
        </v-btn>
      </v-badge>
    </v-fab-transition>

    <SysDialogFullScreen
      v-model="COMPUTED_DIALOG"
      titulo="Combinar Produtos"
      txtBotao="aplicar"
    >
      <template #titulo-parte-direita>
        <v-btn
          color="primary"
          small @click="combinar()"
          :disabled="COMPUTED_SELECIONADO.length == 0"
        >
          Aplicar Combinação
        </v-btn>
      </template>

      <v-data-table
        v-model="COMPUTED_SELECIONADO"
        :headers="GET_HEADERS_COMBINAR"
        :items="GET_SELECIONADOS_DADOS_TABELA"
        :height="alturaDaJanela * 0.88"
        :item-height="25"
        show-select
        single-select
        item-key="idproduto"
        hide-default-footer
        class="elevation-1"
      >
        <template #item.estoque="{ value }">{{ Helpers.formatarValor(value) }}</template>
        <template #item.media_tres_meses="{ value }">{{ Helpers.formatarValor(value) }}</template>
        <template #item.preco_venda_evento="{ value }">{{ Helpers.formatarValorMonetario(value) }}</template>
        <template #item.markup_evento="{ value }">{{ Helpers.formatarValorMonetario(value) }}</template>
        <template #item.venda_periodo_evento="{ value }">{{ Helpers.formatarValor(value) }}</template>
        <template #item.faturamento_evento="{ value }">{{ Helpers.formatarValorMonetario(value) }}</template>

        <template #body.prepend>
          <tr class="tr-td-local">
            <td></td>
            <template v-if="!COMPUTED_TOTALIZADOR_SELECIONADO.descricao_familia_produto">
              <td colspan="4"><strong>TOTALIZADOR</strong></td>
            </template>
            <template v-else>
              <td>{{ COMPUTED_TOTALIZADOR_SELECIONADO.descricao_familia_produto }}</td>
              <td>{{ COMPUTED_TOTALIZADOR_SELECIONADO.razao_social }}</td>
              <td>{{ COMPUTED_TOTALIZADOR_SELECIONADO.idproduto }}</td>
              <td>{{ COMPUTED_TOTALIZADOR_SELECIONADO.descricao_produto }}</td>
            </template>
            <td>{{ Helpers.formatarValor(COMPUTED_TOTALIZADOR_PRODUTOS.estoque) }}</td>
            <td>{{ Helpers.formatarValor(COMPUTED_TOTALIZADOR_PRODUTOS.media_tres_meses) }}</td>
            <td>{{ Helpers.formatarValorMonetario(COMPUTED_TOTALIZADOR_PRODUTOS.preco_venda_evento) }}</td>
            <td>{{ Helpers.formatarValor(COMPUTED_TOTALIZADOR_PRODUTOS.markup_evento) }}%</td>
            <td>{{ Helpers.formatarValor(COMPUTED_TOTALIZADOR_PRODUTOS.quantidade_evento) }}</td>
            <td>{{ Helpers.formatarValorMonetario(COMPUTED_TOTALIZADOR_PRODUTOS.faturamento_evento) }}</td>
          </tr>

          <tr>
            <td colspan="11" class="text-center">
              <strong>
                O ITEM A CIMA SERÁ ADICIONADO AO CARRINHO DO EVENTO
              </strong>
              <v-icon class="mt-n1">mdi-arrow-up</v-icon>
            </td>
          </tr>
        </template>
      </v-data-table>
    </SysDialogFullScreen>
  </div>
</template>

<script>
import SysDialogFullScreen from "@/components/padraoDeLayout/SysDialogFullScreen.vue"
import { mapGetters } from 'vuex'
import Responsividade from '@/helpers/ResponsiveHeight';

export default {
  mixins: [Responsividade],
  components: {
    SysDialogFullScreen
  },
  computed: {
    ...mapGetters({
      GET_HEADERS_COMBINAR: 'EventoSazonalFinal/GET_HEADERS_COMBINAR',
      GET_DIALOG_COMBINAR: 'EventoSazonalFinal/GET_DIALOG_COMBINAR',
      GET_SELECIONADOS_DADOS_TABELA: 'EventoSazonalFinal/GET_SELECIONADOS_DADOS_TABELA',
      GET_DADOS_COMBINAR: 'EventoSazonalFinal/GET_DADOS_COMBINAR'
    }),
    COMPUTED_SELECIONADO: {
      get() { return this.GET_DADOS_COMBINAR },
      set(value) { this.$store.dispatch('EventoSazonalFinal/setDadosCombinar', value) }
    },
    COMPUTED_TOTALIZADOR_PRODUTOS() {
      const arrayDeObjetos = this.GET_SELECIONADOS_DADOS_TABELA;
      const somaValores = {};
      for (const objeto of arrayDeObjetos) {
        for (const chave in objeto) {
          if (chave in somaValores) {
            somaValores[chave] += Number(objeto[chave]);
          } else {
            somaValores[chave] = Number(objeto[chave]);
          }
        }
      }
      return somaValores;
    },
    COMPUTED_TOTALIZADOR_SELECIONADO() {
      const item = {
        ...this.COMPUTED_SELECIONADO[0],
        markup_evento: this.COMPUTED_TOTALIZADOR_PRODUTOS.markup_evento,
        preco_custo_evento: this.COMPUTED_TOTALIZADOR_PRODUTOS.preco_custo_evento,
        preco_venda_evento: this.COMPUTED_TOTALIZADOR_PRODUTOS.preco_venda_evento,
        total_faturamento: this.COMPUTED_TOTALIZADOR_PRODUTOS.total_faturamento,
        quantidade_evento: this.COMPUTED_TOTALIZADOR_PRODUTOS.quantidade_evento,
        combinado: true,
        itens_old_combinados: this.GET_SELECIONADOS_DADOS_TABELA
      }
      return item;
    },
    COMPUTED_DIALOG: {
      get() { return this.GET_DIALOG_COMBINAR },
      set(value) { this.$store.dispatch('EventoSazonalFinal/setDialogCombinar', value); }
    },
    STYLE_BTN_COMBINADO() {
      let estilo = {
        zIndex: '999',
        position: 'absolute',
        right: 0,
        top: 0,
        marginTop: '16px',
        marginRight: '320px'
      };

      return estilo;
    }
  },
  methods: {
    setDialogCombinar() {
      this.$store.dispatch('EventoSazonalFinal/setDialogCombinar', true);
    },
    combinar() {
      this.$store.dispatch('EventoSazonalFinal/combinarAdicionarItensCarrinho', this.COMPUTED_TOTALIZADOR_SELECIONADO);
    }
  },
}
</script>

<style>
.tr-td-local > td {
  /* font-size: 12pt !important; */
  font-weight: bolder;
  background-color: rgba(253, 112, 112, 0.577);
}
</style>
